import axios from 'axios'

export function createWorkflow(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getWorkflows(spaceID, size, page) {
    if (Object.keys(page).length) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/workflows?page[after]=' + page.to + '&page[limit]=' + size, {

            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    } else {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/workflows?page[limit]=' + size, {

            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function searchWorkflowsIsBooster(spaceID, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/workflows?filter[keyword]=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function updateWorkflowTitle(workflowId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function deleteWorkflow(workflowId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function addWorkflowPeople(workflowId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/add-users', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getPeopleInWorkflow(workflowId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/get-users?filter[regular-members]=true&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function removeUserFromWorkflow(workflowId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/remove-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchSpaceUsersWorkflow(spaceId, workflowId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=500&filter[members-excluded-from-workflow]=' + workflowId + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getOwnersInWorkflow(workflowId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/get-users?filter[boosters]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function searchSpaceOwnersWorkflowExcluded(spaceId, workflowId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=500&filter[boosters-excluded-from-workflow]=' + workflowId + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function addWorkflowOwners(workflowId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/add-boosters', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getWorkflowUsersStatistics(workflowId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/get-users-statistics', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getWorkflow(workflowId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getActionTypesWorkflow() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/action-types', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function addWorkflowAction(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflow-actions', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function updateWorkflowAction(actionId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflow-actions/' + actionId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getWorkflowActionsInWorkflow(workflowId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/workflow-actions', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function deleteWorkflowAction(actionId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflow-actions/' + actionId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function saveWorkflowActions(workflowId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/save-actions', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function refreshWorkflowAction(actionId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflow-actions/' + actionId + '/-actions/refresh-action', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getWorkflowActionUsers(actionId, size, page){
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflow-actions/' + actionId + '/-actions/get-users?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function duplicateWorkflow(workflowId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/duplicate', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function downloadWorkflowCertificatePreview(workflowId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflows/' + workflowId + '/-actions/preview-certificate', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
        responseType: 'blob',
    })
}

export function downloadWorkflowCertificate(actionId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/workflow-actions/' + actionId + '/-actions/check-certificate', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
        responseType: 'blob',
    })
}